var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrowL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 38,
    viewBox: "0 0 74 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6152 0.416809H20.0194L0.00108337 18.771H12.5969L32.6152 0.416809Z",
    fill: "#7630FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00195312 18.771H12.5978L32.6161 37.1252H20.0203L0.00195312 18.771Z",
    fill: "#7630FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1582 0.416809H40.5624L20.5441 18.771H33.1399L53.1582 0.416809Z",
    fill: "#7630FF",
    fillOpacity: 0.59
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5449 18.771H33.1407L53.1591 37.1252H40.5633L20.5449 18.771Z",
    fill: "#7630FF",
    fillOpacity: 0.59
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.002 0.416809H61.4061L41.3878 18.771H53.9836L74.002 0.416809Z",
    fill: "#7630FF",
    fillOpacity: 0.33
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3887 18.771H53.9845L74.0028 37.1252H61.407L41.3887 18.771Z",
    fill: "#7630FF",
    fillOpacity: 0.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrowL);
export default __webpack_public_path__ + "static/media/errow_l.2e5d06959d412e623231a4ec56fc3024.svg";
export { ForwardRef as ReactComponent };